import { render, staticRenderFns } from "./PredmetCreate.vue?vue&type=template&id=762f83a6&scoped=true&"
import script from "./PredmetCreate.vue?vue&type=script&lang=js&"
export * from "./PredmetCreate.vue?vue&type=script&lang=js&"
import style0 from "./PredmetCreate.vue?vue&type=style&index=0&id=762f83a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762f83a6",
  null
  
)

export default component.exports